<div class="modal-header">
    <h5 class="modal-title">Sign in to student site</h5>
    <button
        (click)="activeModal.dismiss('Cross click')"
        aria-label="Close"
        class="btn-close"
        data-dismiss="modal"
        type="button"
    ></button>
</div>
<div class="modal-body">
    <!-- Region: Auth Step One -->
    <div *ngIf="studentLogin.shouldDisplayUsernameInput()">
        <div class="student-login-form">
            <p>Access your assignments, projects, and favorites.</p>
        </div>
        <div class="username-input position-relative">
            <app-input-box
                (click)="
                    studentLogin.isLoginInitiated = false;
                    studentLogin.restoreInitialSecretQuestionValue()
                "
                (keydown.enter)="
                    studentLogin.initiateLogin(studentUsername);
                    studentLogin.isLoginInitiated = true
                "
                [(inputModel)]="studentUsername"
                label="Username"
            >
            </app-input-box>
            <app-button
                (click)="
                    studentLogin.initiateLogin(studentUsername);
                    studentLogin.isLoginInitiated = true
                "
                >Next
            </app-button>
        </div>
        <app-error-message
            *ngIf="studentLogin.getSecretQuestion() === null && studentLogin.isLoginInitiated"
            errorMessage="This username does not exist."
        >
        </app-error-message>
    </div>
    <!-- /Region: Auth Step One -->
    <!-- Region: Auth Step Two -->
    <div *ngIf="studentLogin.shouldDisplayQuestionInput()">
        <div class="student-login-form">
            <p>
                <span>Answer your secret question to finish log in</span><br />
                <span>{{ studentLogin.getSecretQuestion() }}</span>
            </p>
        </div>
        <div class="secret-answer-input">
            <app-input-box
                (click)="
                    studentLogin.isLoginValidationInitiated = false;
                    studentLogin.restoreInitialLoginEvaluationValue()
                "
                (keydown.enter)="
                    studentLogin.validateLogin(secretAnswer);
                    studentLogin.isLoginValidationInitiated = true
                "
                [(inputModel)]="secretAnswer"
                label="{{ studentLogin.generateLabelFromSecretQuestion() }}"
            >
            </app-input-box>
            <app-button
                (click)="
                    studentLogin.validateLogin(secretAnswer);
                    studentLogin.isLoginValidationInitiated = true
                "
            >
                Go</app-button
            >
        </div>
        <app-error-message
            *ngIf="
                studentLogin.getLoginValidity() === 'False' &&
                studentLogin.isLoginValidationInitiated
            "
            errorMessage="This answer does not match your original one. Please try again."
        >
        </app-error-message>
    </div>
    <!-- /Region: Auth Step Two -->
    <span class="mb-2 hr-class d-flex flex-row justify-content-center">
        <span class="text-center">or</span>
    </span>
    <div class="google-auth-wrapper py-4 px-3">
        <a
            [href]="loginRedirectLink"
            class="selenium-continue-google d-flex justify-content-center align-items-center"
        >
            <img [src]="googleImage" alt="Sign in with Google" class="auth-icon me-1" />
            <span class="d-flex justify-content-center align-items-center">
                Sign in with Google
            </span>
        </a>
    </div>
    <div>
        <a (click)="openStudentSignUp()" class="sign-up">
            I need to sign up!
            <app-icon [type]="'Arrow-right'"></app-icon>
        </a>
        <div
            class="teacher-callout d-flex flex-row flex-wrap align-content-center justify-content-start align-items-center"
        >
            <span class="pe-2"> Are you a teacher? </span>
            <a (click)="activeModal.close()" [routerLink]="['/']">
                Sign in on our teacher site
                <app-icon [type]="'Arrow-right'"></app-icon>
            </a>
        </div>
    </div>
</div>
